import { render, staticRenderFns } from "./land_page.vue?vue&type=template&id=9597e33c&scoped=true"
import script from "./land_page.vue?vue&type=script&lang=js"
export * from "./land_page.vue?vue&type=script&lang=js"
import style0 from "./land_page.vue?vue&type=style&index=0&id=9597e33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9597e33c",
  null
  
)

export default component.exports